const ENSWOTStrategies = {
	"Inserir estratégia SWOT": "Add SWOT strategy",
	"Alterar estratégia SWOT":"Change SWOT strategy",
	"Deseja realmente excluir a estratégia": "Do you really want to delete the strategy",
	"Estratégia adicionada com sucesso": "Strategy successfully added",
	"Estratégia alterada com sucesso": "Strategy successfully changed",
	"Estratégia excluída com sucesso": "Strategy successfully deleted",
	"Erro ao adicionar estratégia": "Error adding strategy",
	"Erro ao alterar estratégia": "Error changing strategy",
	"Erro ao excluir estratégia": "Error deleting strategy",
	"Exclusão de estratégia SWOT": "Delete SWOT strategy",
	"Digite o nome da estratégia para excluí-la": "Enter the name of the strategy to delete it",
	"Estratégias da SWOT":"SWOT strategies",
	"Estratégias SWOT": "SWOT strategies",
	"Nova estratégia SWOT":"New SWOT strategy"
};

export default ENSWOTStrategies;

